import React from "react";
import { FormEnabler, ValidatedForm, MInput } from "components/forms";

import {
  payloadBuilder,
  invalidFieldsMapper,
  networkErrorHelper,
  adminService,
} from "libs";

import { Card, CardBody, Button } from "design-react-kit";
import ReactHtmlParser from "react-html-parser";
import { BoxInfo } from "components/misc";

export class AdminSurveyQuestion extends ValidatedForm {
  ERROR_MESSAGES = {
    order: "Ordine non valido",
  };

  emptyFields = {
    order: 0,
    label: "",
  };

  validation = {
    order: (value) => /^\d*$/.test(value),
  };

  FIELDS_GROUP = [
    [
      {
        id: "order",
        field: "order",
        label: "Ordine",
        component: MInput,
        type: "number",
        className: "col-sm-6 col-md-4",
      },
    ],
    [
      {
        id: "label-question",
        field: "label",
        label: "Scrivi la domanda",
        component: MInput,
        className: "col-md-12",
      },
    ],
  ];

  constructor(props) {
    super(props);

    this.state = {
      ...this.emptyFields,
      defaultValues: { ...this.emptyFields },
      formActive: this.props.formActive || false,
      idSurvey: parseInt(this.props.idSurvey) || 0,
      idQuestion: parseInt(this.props.idQuestion) || null,
      type: "radio",
      showForm: true,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.state.idQuestion > 0 && this.props.questionValue) {
      const values = this.props.questionValue;
      this.setState({
        ...values,
        defaultValues: { ...values },
        showForm: true,
      });
    }
  }

  addQuestion = () => {
    this.setState({
      ...this.emptyFields,
      defaultValues: { ...this.emptyFields },
      idQuestion: null,
      formActive: true,
      showForm: true,
    });
  };

  onCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else if (this.state.idQuestion === null) {
      this.setState({ showForm: false });
      this.resetForm();
    } else {
      this.setState({ formActive: !this.state.formActive });
    }
  };

  saveRemote = () => {
    const payload = payloadBuilder(this.state);
    let resAPI;

    if (this.state.idQuestion > 0) {
      resAPI = adminService.updateSurveyQuestion(payload).then(() => {
        this.setState({ formActive: false });
      });
    } else {
      payload.idSurvey = this.state.idSurvey;
      payload.type = this.state.type;
      resAPI = adminService.insertSurveyQuestion(payload).then((result) => {
        this.setState({ idQuestion: result.data.payload.surveyQuestion.id });
        this.props.loadQuestions(this.state.idSurvey);
        this.props.onCancel();
      });
    }

    resAPI.catch((errors) => {
      if (networkErrorHelper.is422(errors)) {
        const newState = invalidFieldsMapper(
          errors,
          this.state,
          Object.keys(this.validation)
        );
        this.setState({ ...newState });
      } else {
        networkErrorHelper.notify(errors);
      }
    });
  };

  renderForm = (formActive, defaultValues) => {
    const { formValid, code } = this.renderFields(
      this.FIELDS_GROUP,
      defaultValues,
      formActive
    );

    return (
      <Card className="card-big mt-4 ">
        <CardBody className="card-body-inAccordion">
          <form className="user">{code}</form>

          <div className="mt-4 mb-3 clearfix">
            <FormEnabler
              onSubmit={this.onSubmit}
              onCancel={this.onCancel}
              onToggle={this.toggleForm}
              isFormActive={formActive}
              disableSave={!formValid}
            />

            {this.state.idQuestion > 0 && (
              <Button
                color="primary bg-dark"
                className="mx-2 mt-6"
                onClick={this.props.deleteRecord}
              >
                Elimina
              </Button>
            )}
          </div>

          <BoxInfo className="text-left mt-5">
            <div className="font-weight-bold">Anteprima domanda:</div>
            {ReactHtmlParser(defaultValues.label)}
          </BoxInfo>
        </CardBody>
      </Card>
    );
  };

  render() {
    const { formActive, defaultValues, showForm } = this.state;

    return <>{showForm && this.renderForm(formActive, defaultValues)}</>;
  }
}
